// eslint-disable-next-line
/* eslint-disable */
var domtoimage = require("dom-to-image");
import jsPDF from "jspdf";
export default {
methods: {
exportPDF: function (id, title) {
   // var node = document.getElementById(id);
    var sel = document.getElementById(id);
            // var node = sel.cloneNode(true);
            sel.style.background = "white";
            // node.clientWidth = sel.clientWidth;
            // node.clientHeight = sel.clientHeight;
    domtoimage.toJpeg(sel)
      .then(function(dataUrl) {
        console.log(dataUrl, 'in')
         let png64 =
                "data:application/octet-stream;base64," +
                dataUrl.split("base64,")[1];
            var i = new Image();
            i.onload = function () {
                let heightratio = 1.0;
                if (i.height <= 500) heightratio = 1.01;
                else if (i.height <= 800) heightratio = 0.94;
                else if (i.height <= 1000) heightratio = 0.90;
                else if (i.height <= 1200) heightratio = 0.86;
                else heightratio = 0.82;

                let wratio = 1.0;
                if (i.width <= 500) wratio = 0.98;
                else if (i.width <= 800) wratio = 0.94;
                else if (i.width <= 1000) wratio = 0.90;
                else if (i.width <= 1200) wratio = 0.86;
                else wratio = 0.80;

                var doc = new jsPDF(i.width > i.height ? "l" : "p", "px", [
                    i.width * wratio,
                    i.height * heightratio
                ]);
                doc.addImage(dataUrl, "JPG", 40, 30);

                title = title.replace(/\s+/g, '-');
                doc.save(title + ".pdf");
            };
            i.src = dataUrl;
      })
    }
}
}


// WEBPACK FOOTER //
// ./src/components/mixins/exportPdf.js